export default function Badge({ children = 'Backup' }) {
  return (
    <div className="md:min-w-[160px] h-fit relative bg-gradient-to-r from-[rgba(252,0,33,1)] via-[rgba(252,0,33,1)] to-[rgba(85,52,217,1)] p-px text-white rounded-[8px] inline-flex items-center justify-center">
      <div className="bg-[rgba(4,1,22,1)] w-full text-center rounded-[8px] px-7 md:px-3 py-3 text-xs md:text-lg font-inter-light text-nowrap">
        {children}
      </div>
    </div>
  )
}
